// removed by extract-text-webpack-plugin
module.exports = {"formatted-date":"_3OvnYIqu2wkz0VG16gOwVw","formattedDate":"_3OvnYIqu2wkz0VG16gOwVw","spin":"_1ueNMprAwAuXuVoEF0uYSZ","slide-in":"xM7Ayw27XgQ1i4nIJe16i","slideIn":"xM7Ayw27XgQ1i4nIJe16i"};


//////////////////
// WEBPACK FOOTER
// ./src/vendor/react-store/components/View/FormattedDate/styles.scss
// module id = 139
// module chunks = 8